module.exports = __webpack_public_path__ + "img/advantage_icon_service.04d1acf9.svg";